import React, { useEffect } from 'react';
import AdminLayout from './Admin-panel/AdminLayout';
import Dashboard from './Admin-panel/Dashboard';
import AdminBlogs from './Admin-panel/AdminBlogs';
import Projects from './Admin-panel/Projects';
import Products from './Admin-panel/Products';
import OurServices from './Admin-panel/OurServices';
import AdminLogin from './Admin-panel/AdminLogin';
import ProtectedRoute from './Admin-panel/ProtectedRoute';
import './App.css';
import Main from './Main';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminUser from './Admin-panel/AdminUser';
import AdminCategories from './Admin-panel/AdminCategories';
import AdminCareers from './Admin-panel/AdminCareers';
import AdminReviews from './Admin-panel/AdminReviews';
import AdminCareerApplications from './Admin-panel/AdminCareerApplications';
import Careers from './Details-page/Careers';
import Productsview from './Details-page/Productsview';
import ProductDetailspage from './Details-page/ProductDetailspage';
import ProjectDetailspage from './Details-page/ProjectDetailspage';
import Projectview from './Details-page/Projectview';
import ServicesDetails from './Details-page/ServicesDetails';
import BlogsDetails from './Details-page/BlogsDetails';
import Blogsviews from './Details-page/Blogsviews';
import AboutSafproview from './Details-page/AboutSafproview';
import Contactus from './Details-page/Contactus';

import { HelmetProvider } from "react-helmet-async";
import useAnalytics from "./useAnalytics";


const pageTitles = {
  "/": "SAFPRO Technology Solutions | Software Development and Services",

  "/about-safproview":
    "Offshore Web, Mobile & E-commerce Development",

  "/projects":
    "High-End, Cutting-Edge Software Development Projects",

  
  "/productsview":
    'Solutions designed to simplify operations.',

  "/careers": "Build your career with us",

  "/contactus": "Reach out to us for more details",

  "/blogs": "Blogs & Insights | Latest Articles and Updates",
  // Admin
  "/admin/login": "Admin Login",
  "/admin/dashboard": "Admin Dashboard",
  "/admin/blogs": "Admin | Manage Blogs",
  "/admin/projects": "Admin | Manage Projects",
  "/admin/products": "Admin | Manage Products",
  "/admin/services": "Admin | Manage Services",
  "/admin/users": "Admin | Manage Users",
  "/admin/categories": "Admin | Manage Categories",
  "/admin/careers": "Admin | Manage Careers",
  "/admin/reviews": "Admin | Manage Reviews",
  "/admin/careers/applications": "Admin | Job Applications",
};

function DynamicTitle() {
  const location = useLocation();

  useEffect(() => {
    const base = "SAFPRO Technology Solutions";
    const path = location.pathname.toLowerCase();

    let title = base;

    if (pageTitles[path]) {
      title = pageTitles[path];
    }

    document.title = title;
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function AnalyticsTracker() {
  useAnalytics();
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AnalyticsTracker />
        <DynamicTitle />

        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/productsview" element={<Productsview />} />
          <Route path="/projects" element={<Projectview />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/about-safproview" element={<AboutSafproview />} />
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route path="/product/:slug" element={<ProductDetailspage />} />
          <Route path="/project/:slug" element={<ProjectDetailspage />} />
          <Route path="/services/:slug" element={<ServicesDetails />} />
          <Route path="/blog/:slug" element={<BlogsDetails />} />

          <Route path="/blogs" element={<Blogsviews />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="projects" element={<Projects />} />
            <Route path="products" element={<Products />} />
            <Route path="services" element={<OurServices />} />
            <Route path="users" element={<AdminUser />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="careers" element={<AdminCareers />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="careers/applications" element={<AdminCareerApplications />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
